<template>
    <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
        <template slot="header">
            <th :class="StyleTh+' text-center'">#</th>
            <th :class="StyleTh">Nombre Comercial</th>
            <th :class="StyleTh">Razón Social</th>
            <th :class="StyleTh">RFC</th>
            
            <th :class="StyleTh+' text-center'">*</th>
        </template>

        <template slot="body">
            <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                <td>
                    <p :class="StyleTd">{{lista.NombreComercial}}</p>
                </td>
                <td>
                    <p :class="StyleTd">{{lista.RazonSocial}}</p>
                </td>
                <td>
                    <p :class="StyleTd">{{lista.RFC}}</p>
                </td>
                
                <td class="align-middle text-end">
                    <button @click="SeleccionarCliente(lista)" type="button" class="btn btn-link text-primary px-3 mb-0 mr-1"><i class="fas fa-check-circle text-primary"></i> Agregar</button>
                </td>
            </tr>
            <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="9"></CSinRegistros>
        </template>
    </CList>
</template>

<script>

import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionClientes';

export default {
    name: 'ListaClientes',
    props: ['poBtnSave'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: '',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: false,
                BtnNewShow: false,
                TitleFirst: '',
                ShowTitleFirst: false,
                ShowFooter: false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            Emit: this.poBtnSave.EmitSeccion,
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ListaAgregados: [],
            IdCliente: 0,
            RFCcliente: '',
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("agentes",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                //this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        SeleccionarCliente(item)
        {
            let obj = {
                IdAgente: item.IdAgente,
                RazonSocial: item.RazonSocial,
                Rfc: item.RFC,
                CP: item.CP,
                RegimenFiscal: item.RegimenFiscal,
            };

            this.bus.$emit('AgregarClienteNota',obj);
            this.bus.$emit('CloseModal_'+this.Emit);
        },
    },
    created()
    {
        this.bus.$off('List_'+EmitEjecuta);

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(obj)=>
        {
            this.Lista();
        });
    },
    mounted()
    {
        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });
    }
}
</script>